<template>
  <v-app id="daisukeApp">
    <v-app-bar clipped-left app class="daisuke-main-bar">
      <div class="app-bar-icon">
        <nuxt-link to="/">
          <v-img
            height="60"
            max-width="250"
            contain
            :src="'customers/afocelca/afocelca_color_horizontal_transparente.png'"
          />
        </nuxt-link>
      </div>
      <v-toolbar-title style="width: 400px" class="ml-0 pt-1">
        <span class="hidden-sm-and-down">{{ title | capitalize }}</span>
      </v-toolbar-title>
      <v-spacer />
      <client-only>
        <profile-menu />
      </client-only>
    </v-app-bar>
    <nuxt />
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";
import ProfileMenu from "@/components/ProfileMenu";

export default {
  middleware: ["auth"],
  components: { Snackbar, ProfileMenu },
  data({ $config }) {
    return {
      mainTitle: $config.PAGE_TITLE,
    };
  },
  computed: {
    title() {
      if (this.$route.path.includes("/users"))
        return this.$t("user access manager");
      return this.$t("applications");
    },
  },
};
</script>

<style lang="scss">
#daisukeApp {
  .daisuke-main-bar .v-toolbar__content {
    padding: 0 16px 0 0;
  }
  .bordered-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  .v-input.v-input--is-disabled input,
  .v-select,
  .v-label {
    color: #00000099;
  }
  .v-select__selection--disabled {
    color: #2c2c2c;
  }
  .v-text-field--outlined.v-input--is-disabled fieldset {
    border-color: #0000000d;
  }
  .v-badge__badge .v-icon {
    color: inherit;
    font-size: 12px;
    margin: 0 -2px;
  }
}
</style>
